module.exports = __webpack_public_path__ + "static/media/bennett-construction-ltd.b394a1f8.png";